import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { greyAreaCSS } from '../../shared/Constants';
import classes from './DataTable.css';

const dataTable = (props) => {

    const defaultSorted = [ {
        dataField: 'id',
        order: 'asc'}
    ];

    const rowEvents ={
        onDoubleClick: (e, row, rowIndex) => {
            props.clicked(row, rowIndex);
        }
    };

    return (
        <div style={{"position": props.greyArea?"relative": ""}}>
            {props.title ? <h3 className={classes.TableTitle}>{props.title}</h3> : null}
            {props.greyArea && <div style={greyAreaCSS}></div>}
            <BootstrapTable
                height='120'
                classes={props.extendXScroll ? classes.ExtendTable  : classes.DataTable}
                keyField="id"
                data={props.data}
                columns={props.columns}
                rowEvents={rowEvents}
                defaultSorted={defaultSorted}
                bordered={false}
                hover
                condensed={props.extendXScroll ? false  : true}
            />
            {props.paginationComponent}
        </div>);

}

export default dataTable;